import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { duplicateTaskList } from "~/store/actions/actions.taskLists.jsx";
import { fetchOpenTasksForTaskList } from "~/store/actions/actions.tasks.jsx";
import { DuplicateObjectDialog } from "../DuplicateObjectDialog/DuplicateObjectDialog.jsx";

export const TaskListDuplicateDialog = ({ open, projectId, id, name, onDuplicateSuccess, onCancel }) => {
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const handleDuplicate = useCallback(
    ({ name }) => {
      if (typeof onDuplicateSuccess === "function") {
        onDuplicateSuccess();
      }
      dispatch(duplicateTaskList(projectId, id, name)).then((result) => {
        if (result && result.response && result.response.result && result.response.result.single) {
          dispatch(fetchOpenTasksForTaskList(projectId, result.response.result.single));
        }
      });
    },
    [projectId, dispatch, id, onDuplicateSuccess]
  );

  return (
    <DuplicateObjectDialog
      open={open}
      name={name}
      title={t("Duplicate Task List")}
      labelText={t("Task list name")}
      explainerText={t("All tasks from this list and their subtasks will be copied to the new task list.")}
      onSubmit={handleDuplicate}
      onCancel={onCancel}
    />
  );
};

TaskListDuplicateDialog.propTypes = {
  projectId: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  open: PropTypes.bool,
  name: PropTypes.string,
  onDuplicateSuccess: PropTypes.func,
  onCancel: PropTypes.func,
};

TaskListDuplicateDialog.defaultProps = {
  open: false,
  name: "",
};
